import { Outlet } from 'react-router-dom'

const PromoBatch = () => <Outlet />

export default PromoBatch
